export default __webpack_public_path__ + "static/media/moonEmoji.8a8adf86.png";